import './DisableFrame.less';

const DisableFrame = (props) => {
  return <div className='video-call-disable-frame' />;
};

export default DisableFrame;
